import React, { useContext } from 'react';

const BlockedSessionContext = React.createContext(false);

export const useBlockedSession = () => useContext(BlockedSessionContext);

export default BlockedSessionContext;
